// extracted by mini-css-extract-plugin
module.exports = {"bg":"style_bg__2lWzg","title":"style_title__1HejR","container":"style_container__fPt0e","wrapper":"style_wrapper__3KfiF","img":"style_img__3sDHh"};